export { CordovaService } from './cordova.service';
